import Vue from 'vue'
import Vuex from 'vuex'

import common from './modules/common'
import home from './modules/home'

Vue.use(Vuex)

// const isDev = process.env.NODE_ENV === 'development';
// console.log(process.env.NODE_ENV)
export default new Vuex.Store({
  // strict: isDev,
  modules: {
    common,
    home
  }
})